var render = function render(_c,_vm){return _c('div',{staticClass:"placeholder",style:({ height: `${_vm.props.height}px` })},[_c('div',{staticClass:"placeholder__background"})])
}
var staticRenderFns = []

export { render, staticRenderFns }